export default {
  Apportionments: {
    HEADING: 'Apportionments',
    DESCRIPTION:
      'Apportionments define how transactions are recharged. This could be based on their headcounts, or how many customers they serve, or how much floorspace they occupy.',
    CROSS_ENTITY_DESCRIPTION: '',
    INTRA_ENTITY_DESCRIPTION:
      'Entity-level apportionments define common ways to recharge transactions between account codes or tracking categories in a single entity.',
    NO_INTRA_ENTITY: "You don't have any apportionments in {{name}} yet",
    APPORTIONMENT: 'Apportionment',
    APPLY_CROSSENTITY: 'Choose an inter-entity apportionment:',
    APPLY_INTRAENTITY: 'Apply an entity apportionment:',
    TOTAL: 'Total apportionment units',
    ADD_NEW: '+ Add new',
    ADD_ENTITY: '+ Add another entity',
    ADD_SPLIT: '+ Add another split',
    SPLIT_WITHIN: '+ Split the transaction within {{name}}',
    SPLIT_FURTHER: '+ Split the transaction further',
    GROUP_SAVE_SUCCESS: 'Group apportionments were saved successfully',
    ENTITY_SAVE_SUCCESS:
      'Intra-entity apportionments for {{name}} were saved successfully',
    LOCKED_CALCULATIONS:
      'Changes you make here will not affect locked calculations.',
    LOAN_ACCOUNT_CODE:
      'This account is configured in one the intercompany balances, so please think carefully before using it in a recharge rule',
  },
};
